import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiArrowRight, FiCheckCircle, FiClock } from 'react-icons/fi';
import { Seo } from '../components/Seo';
import { site } from '../config/site';
import { offers } from '../data/offers';
import { Icon } from '../components/ui/Icon';

export default function OffersPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${site.name} — Offres`,
    url: `${site.url}/offres`,
    inLanguage: 'fr-FR',
  };

  return (
    <>
      <Seo
        title="Offres & avis"
        description="Liste d’offres de paris sportifs en France: bonus, conditions, retraits et avis détaillés par opérateur."
        canonicalPath="/offres"
        jsonLd={jsonLd}
      />

      <section className="lbf-container py-12 sm:py-16">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h1 className="text-3xl font-black tracking-tight text-white sm:text-4xl">Offres & avis</h1>
            <p className="mt-3 max-w-2xl text-sm text-zinc-200/80">
              Ici, chaque page d’offre est construite comme une checklist: bonus, conditions, retraits, profils et
              graphiques. Pas de blabla.
            </p>
          </div>
          <NavLink to="/comparatif-offres" className="lbf-btn-primary">
            Comparatif complet <Icon icon={FiArrowRight} aria-hidden="true" />
          </NavLink>
        </div>

        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {offers.map((o) => (
            <NavLink
              key={o.slug}
              to={`/offres/${o.slug}`}
              className="lbf-card group overflow-hidden p-5 transition hover:bg-white/10"
            >
              <div className="flex items-center gap-3">
                <img
                  src={o.imagePath}
                  alt={o.brand}
                  className="h-12 w-12 rounded-2xl border border-white/10 bg-white/5 object-contain p-1"
                  loading="lazy"
                  decoding="async"
                />
                <div>
                  <div className="text-base font-extrabold text-white">{o.brand}</div>
                  <div className="text-xs text-zinc-300/80">{o.tagline}</div>
                </div>
              </div>

              <div className="mt-4 flex flex-wrap gap-2">
                <span className="lbf-badge">
                  <Icon icon={FiCheckCircle} aria-hidden="true" />
                  {o.welcome.headline}
                </span>
                <span className="lbf-badge">
                  <Icon icon={FiClock} aria-hidden="true" />
                  ~{o.payouts.typicalHours}h
                </span>
              </div>

              <p className="mt-4 text-sm text-zinc-200/85">{o.heroPitch}</p>

              <div className="mt-5 text-xs font-semibold text-white/80 group-hover:text-white">
                Ouvrir l’avis <Icon icon={FiArrowRight} className="ml-1 inline" aria-hidden="true" />
              </div>
            </NavLink>
          ))}
        </div>
      </section>
    </>
  );
}


